import DynamicFormField from './DynamicFormField';
import type { DynamicFormFieldProps } from './DynamicFormField.types';

export type { DynamicFormFieldProps };
export default DynamicFormField;
